export const MAIN_EMAIL = 'AritLogic@gmail.com'
